import { NgModule } from '@angular/core';

import { ReadUtilitiesServicePropertyPipe } from './read-utilities-service-property.pipe';
import { DomainValuesPipe } from './domain-values.pipe';
import { LocalizedLabelPipe } from './localized-label.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { StatusNumberPipe } from './status-number.pipe';
import { GetValueOrLabelPipe } from './get-value-or-label.pipe';
import { ReadDatetimeServicePropertyPipe } from './read-datetime-service-property.pipe';
import { LabelFallbackPipe } from './label-fallback.pipe';
import { FormDefinitionPropertyPipe } from './form-definition-property.pipe';
import { StatusValuePipe } from './status-value.pipe';
import { StatusLabelPipe } from './status-label.pipe';
import { DomainValuePipe } from './domain-value.pipe';
import { FormatDatePipe } from './format-date.pipe';
import { ArrayToStringPipe } from './array-of-string.pipe';
import { HasAnEntryPipe } from './has-an-entry.pipe';
import { RoundNumberForUnitPipe } from './round-number-for-unit.pipe';
import { HasNewLinePipe } from './has-new-line.pipe';
import { HasAnnualPlanPipe } from './has-annual-plan.pipe';
import { HasValidEntriesPipe } from './has-valid-entries.pipe';

@NgModule({
  declarations: [
    LocalizedLabelPipe,
    DomainValuePipe,
    DomainValuesPipe,
    ReadUtilitiesServicePropertyPipe,
    ReadDatetimeServicePropertyPipe,
    SafeHtmlPipe,
    StatusNumberPipe,
    GetValueOrLabelPipe,
    LabelFallbackPipe,
    FormDefinitionPropertyPipe,
    StatusValuePipe,
    StatusLabelPipe,
    FormatDatePipe,
    ArrayToStringPipe,
    HasAnEntryPipe,
    RoundNumberForUnitPipe,
    HasNewLinePipe,
    HasAnnualPlanPipe,
    HasValidEntriesPipe,
  ],
  exports: [
    LocalizedLabelPipe,
    DomainValuePipe,
    DomainValuesPipe,
    ReadUtilitiesServicePropertyPipe,
    ReadDatetimeServicePropertyPipe,
    SafeHtmlPipe,
    StatusNumberPipe,
    GetValueOrLabelPipe,
    LabelFallbackPipe,
    FormDefinitionPropertyPipe,
    StatusValuePipe,
    StatusLabelPipe,
    FormatDatePipe,
    ArrayToStringPipe,
    HasAnEntryPipe,
    RoundNumberForUnitPipe,
    HasNewLinePipe,
    HasAnnualPlanPipe,
    HasValidEntriesPipe,
  ],
})
export class PipesModule {}
